#### `countryCode` required for location inference

We have updated our schema for [`inferLocation` query], now making the `countryCode` value mandatory for all requests.

This field accepts a two-letter [ISO 3166-1:2013 country code] of the location, in uppercase.

Previously, `countryCode` was optional, but subsequent testing has demonstrated that `countryCode` significantly improves the quality of inference and avoids cases of incorrect locations being returned that impact hirer experience.

No impact to existing implementations is expected.

[`inferLocation` query]: /use-cases/job-posting/locations#inferlocation
[ISO 3166-1:2013 country code]: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
